import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { strings } from '@/constants/residents/strings';
import { DesktopSectionHeader } from '@/components/residents/desktop/myAccount/DesktopSectionHeader';
import { useNotificationPreferences } from '@/hooks/residents/useNotificationPreferences';
import { NotificationToggleRow } from '@/components/residents/account/NotificationToggleRow';
import { NOTIFICATION_TYPES } from '@/constants/residents/notifications';

export const NotificationSettingsView: React.FC = () => {
  const { getValue, togglePreference } = useNotificationPreferences();

  // Web keys
  const KEY_MESSAGE = NOTIFICATION_TYPES.message.key;
  const KEY_UPCOMING_EVENT = NOTIFICATION_TYPES.upcomingEvent.key;
  const KEY_EVENT_RSVP = NOTIFICATION_TYPES.eventRsvp.key;
  const KEY_BULLETIN = NOTIFICATION_TYPES.bulletin.key;

  const onToggle = (key: string, next: boolean) => {
    togglePreference(key, next, 'push');
  };

  return (
    <View style={styles.root}>
      <DesktopSectionHeader
        title={strings.notifications.settings.title}
        subtitle={strings.notifications.settings.description}
        containerStyle={styles.header}
        titleStyle={styles.headerTitle}
        subHeaderContainerStyle={styles.subHeader}
        subHeaderTextStyle={styles.subHeaderText}
      />
      <View style={styles.body}>
        <NotificationToggleRow 
          label={strings.notifications.settings.newMessages.label}
          subtitle={strings.notifications.settings.newMessages.description}
          value={getValue(KEY_MESSAGE)} 
          onChange={(v) => onToggle(KEY_MESSAGE, v)} 
        />
        <NotificationToggleRow 
          label={strings.notifications.settings.upcomingEvents.label}
          subtitle={strings.notifications.settings.upcomingEvents.description}
          value={getValue(KEY_UPCOMING_EVENT)} 
          onChange={(v) => onToggle(KEY_UPCOMING_EVENT, v)} 
        />
        <NotificationToggleRow 
          label={strings.notifications.settings.rsvpReminders.label}
          subtitle={strings.notifications.settings.rsvpReminders.description}
          value={getValue(KEY_EVENT_RSVP)} 
          onChange={(v) => onToggle(KEY_EVENT_RSVP, v)} 
        />
        <NotificationToggleRow 
          label={strings.notifications.settings.newBulletins.label}
          subtitle={strings.notifications.settings.newBulletins.description}
          value={getValue(KEY_BULLETIN)} 
          onChange={(v) => onToggle(KEY_BULLETIN, v)} 
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: { flex: 1, backgroundColor: RESIDENTS_DESKTOP_COLORS.PRIMARY_BACKGROUND },
  header: { borderBottomWidth: 1, borderBottomColor: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY, paddingHorizontal: 20, paddingVertical: 14 },
  headerTitle: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, fontWeight: '800', fontSize: 18 },
  subHeader: { borderBottomWidth: 1, borderBottomColor: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY, paddingHorizontal: 20, paddingVertical: 14 },
  subHeaderText: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, fontWeight: '600' },
  body: { paddingVertical: 24 , paddingHorizontal: 20 },
  sectionTitle: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, fontWeight: '600', fontSize: 16, marginBottom: 8 },
  toggleRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 12, borderBottomWidth: 1, borderBottomColor: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY },
  toggleCopy: { flex: 1, paddingRight: 12 },
  toggleLabel: { color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY, fontSize: 16, fontWeight: '700' },
  toggleSub: { color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY, fontSize: 14 },
});

export default NotificationSettingsView;


